import React, { useState } from "react";
import {
  CircularProgress,
  Stack,
  useTheme,
  TextField,
  Button,
} from "@mui/material";
import { SectionTitle } from "../../molecules";
import { phoneIcon, phoneIconC } from "../../../assets";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { addEndpoint, api, apiUrls } from "../../../services/apiService";
import { setRegister } from "../../../redux/slices/registerSlice";
import { setAlert } from "../../../redux/slices/alertSlice";

export const OTPSection = ({ onClickNext }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const dispatch = useDispatch();
  const regData = useSelector((state) => state.register);
  const theme = useTheme();

  const validateOtp = async (value) => {
    try {
      const response = await api.post(
        apiUrls.validateOtp +
          addEndpoint([
            regData.name,
            regData.phoneNumber,
            regData.email,
            regData.idNumber,
            value,
            regData.password,
          ])
      );
      if (response.data.status) {
        setIsLoading(false);
        dispatch(setRegister({ recordID: response.data.recordID }));
        onClickNext();
      } else {
        dispatch(
          setAlert({
            message: "OTP Salah",
            isOpen: true,
          })
        );
      }
    } catch (error) {
      dispatch(
        setAlert({
          message: error.messasge,
          isOpen: true,
        })
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    setIsLoading(true);
    await validateOtp(values);
  };

  return (
    <Stack
      spacing="32px"
      justifyContent="space-between"
      style={{ height: "100%" }}
    >
      <Stack spacing="32px">
        {/* SECTION TITLE */}
        <SectionTitle
          image={theme.palette.mode === "dark" ? phoneIcon : phoneIconC}
          title="Masukkan Kode Verifikasi"
          subtitle={`Kode verifikasi telah dikirim ke ${regData.email}`}
        />

        {/* OTP INPUT (Simple TextField) */}
        <TextField
          label="Kode OTP"
          value={otp}
          onChange={(e) => setOtp(e.target.value.toUpperCase())}
          inputProps={{ maxLength: 5 }}
          fullWidth
        />
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleSubmit(otp)}
          disabled={isLoading || otp.length !== 5}
          startIcon={isLoading ? <CircularProgress size={20} /> : null}
        >
          {isLoading ? "Memverifikasi..." : "Verifikasi"}
        </Button>
      </Stack>

      {/* LOADING ANIMATION */}
      {isLoading && (
        <div style={{ textAlign: "center" }}>
          <CircularProgress />
        </div>
      )}
    </Stack>
  );
};

OTPSection.propTypes = {
  onClickNext: PropTypes.func,
};
